'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMaps = exports.fetchRegionGeoJson = exports.searchMapByStormDate = exports.markMapAsUnFinished = exports.markMapAsFinished = exports.fetchImpactingMaps = exports.fetchFavoriteMaps = exports.favoriteMap = exports.searchMaps = exports.fetchRecentMaps = exports.fetchMapById = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchMapById = exports.fetchMapById = function fetchMapById(id) {
  return (0, _callApi2.default)('GET', '/map/' + id, null, 'application/json');
};
var fetchRecentMaps = exports.fetchRecentMaps = function fetchRecentMaps() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return (0, _callApi2.default)('POST', '/maps/search/newest', { limit: limit, offset: offset }, 'application/json');
};
var searchMaps = exports.searchMaps = function searchMaps(startDate, endDate) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return (0, _callApi2.default)('POST', '/maps/search', { startDate: startDate, endDate: endDate, limit: limit, offset: offset }, 'application/json');
};
var favoriteMap = exports.favoriteMap = function favoriteMap(id) {
  return (0, _callApi2.default)('GET', '/map/favorite/' + id, null, 'application/json');
};
var fetchFavoriteMaps = exports.fetchFavoriteMaps = function fetchFavoriteMaps(f) {
  return (0, _callApi2.default)('POST', '/maps/search/favorites', {}, 'application/json');
};
var fetchImpactingMaps = exports.fetchImpactingMaps = function fetchImpactingMaps(coords) {
  return (0, _callApi2.default)('GET', '/maps/coords/' + coords.lat + ';' + coords.lng);
};
var markMapAsFinished = exports.markMapAsFinished = function markMapAsFinished(map_id) {
  return (0, _callApi2.default)('PUT', '/maps/mark-as-finished', { map_id: map_id }, 'application/json');
};
var markMapAsUnFinished = exports.markMapAsUnFinished = function markMapAsUnFinished(map_id) {
  return (0, _callApi2.default)('PUT', '/maps/mark-as-unfinished', { map_id: map_id }, 'application/json');
};
var searchMapByStormDate = exports.searchMapByStormDate = function searchMapByStormDate(date) {
  return (0, _callApi2.default)('POST', '/maps/search/detailed', { date: date }, 'application/json');
};
var fetchRegionGeoJson = exports.fetchRegionGeoJson = function fetchRegionGeoJson(region_path) {
  return (0, _callApi2.default)('POST', '/maps/regions/fetch', { region_path: region_path }, 'application/json');
};

//****enligtened api calls******//
var fetchMaps = exports.fetchMaps = function fetchMaps(options) {
  return (0, _callApi2.default)('POST', '/map/find', _extends({}, options), 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/maps.js
// module id = 735
// module chunks = 0